import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { getFieldPracticeTimestamps } from "services";

import { GET_FIELD_PRACTICE_TIMESTAMPS } from "consts";

// last update time of every crop, seeding, tillage and fertilizer row on a field, by row id
export const useGetFieldPracticeTimestamps = ({ fieldId, enabled }: { fieldId: string; enabled: boolean }): UseQueryResult<Record<string, string>> =>
  useQuery<Record<string, string>>({
    queryKey: [GET_FIELD_PRACTICE_TIMESTAMPS, fieldId],
    queryFn: async () => {
      const practiceTimestamps = await getFieldPracticeTimestamps({ fieldId });

      return Object.fromEntries(practiceTimestamps.map(({ id, updatedAt }) => [id, updatedAt]));
    },
    enabled: enabled && !!fieldId,
    // a save changes these rows, so every opened drawer reads them fresh
    staleTime: 0,
  });
